/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('TestLibraryServiceApi', ($http, ApiErrorService) => {
    return {
        getSimulatorTestSuites: getSimulatorTestSuites,
        getActiveTestLibrary: getActiveTestLibrary,
        setActiveTestLibrary: setActiveTestLibrary,
        getTestCaseDetails: getTestCaseDetails,
        getMessageStructure: getMessageStructure,
        getTestCaseMessages: getTestCaseMessages,
        lockTestCase: lockTestCase,
        commitTestCaseChanges: commitTestCaseChanges,
        revertTestCaseChanges: revertTestCaseChanges,
        getTestOperationMessage: getTestOperationMessage,
        getTestOperationDetails: getTestOperationDetails,
        deleteTestCase: deleteTestCase,
        renameTestCase: renameTestCase,
        changeTestCaseDescription: changeTestCaseDescription,
        addTestCase: addTestCase,
        cloneTestCase: cloneTestCase,
        addTestFolder: addTestFolder,
        deleteTestFolder: deleteTestFolder,
        renameTestFolder: renameTestFolder,
        changeTestFolderDescription: changeTestFolderDescription,
        updateTestOperationMessage: updateTestOperationMessage,
        updateTestCaseTriggeringConditions: updateTestCaseTriggeringConditions,
        deleteTestOperation: deleteTestOperation,
        synchStatus: synchStatus,
        activeTestLibraryItems: activeTestLibraryItems,
        changeItemPosition: changeItemPosition
    };
    function getSimulatorTestSuites(simId, userId, onlyRepo) {
        return $http.get(`api/simulator/${simId}/TestLibraries?userId=${userId}&onlyRepo=${onlyRepo}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getActiveTestLibrary(simId, userId) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function setActiveTestLibrary(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestCaseDetails(simId, userId, testCaseUid) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/details?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getMessageStructure(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/messageStructure?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestCaseMessages(simId, userId, testCaseUid) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/messages?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function lockTestCase(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/lock?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function commitTestCaseChanges(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function revertTestCaseChanges(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/wip/delete?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestOperationMessage(simId, userId, testCaseUid, opeUid) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/${encodeURIComponent(opeUid)}/messageTestOperationDetail?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestOperationDetails(simId, userId, testCaseUid, opeUid) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/${encodeURIComponent(opeUid)}/testOperationDetails?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteTestCase(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/delete?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function renameTestCase(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/name?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function changeTestCaseDescription(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/description?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addTestCase(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/addTestCase?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function cloneTestCase(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/clone?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addTestFolder(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/addTestFolder?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteTestFolder(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/deleteTestFolder?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function renameTestFolder(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/renameTestFolder?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function changeTestFolderDescription(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/changeTestFolderDescription?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updateTestOperationMessage(simId, userId, testCaseUid, opeUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/${encodeURIComponent(opeUid)}?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updateTestCaseTriggeringConditions(simId, userId, testCaseUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/triggeringConditions?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteTestOperation(simId, userId, testCaseUid, opeUid) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/${encodeURIComponent(testCaseUid)}/${encodeURIComponent(opeUid)}/delete?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function synchStatus(simId, userId) {
        return $http.get(`api/simulator/${simId}/SynchStatus?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function activeTestLibraryItems(simId, userId) {
        return $http.get(`api/simulator/${simId}/ActiveTestLibrary/view?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function changeItemPosition(simId, userId) {
        return $http.post(`api/simulator/${simId}/ActiveTestLibrary/position?userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
